import React from 'react'

import { Grid } from 'lese'
import Section, { SectionHeader } from 'Components/Section'
import { convertToReadableDate } from 'Helpers'

import GridRow from 'Components/Grid/GridRow'
import GridHeader from 'Components/Grid/GridHeader'

const PatientTable = ({ patient }) => (
  <>
    {patient.journeys
      .sort((a, b) => b.formsCompleted - a.formsCompleted)
      .map(journey => (
        <GridRow>
          <div>{patient.patientRef}</div>
          <div>{patient.initials}</div>
          <div>{journey.tCode}</div>
          <div>{journey.name}</div>
          <div>{convertToReadableDate(journey.startDate)}</div>
          <div>{journey.formsSent}</div>
          <div>{journey.formsCompleted}</div>
          <div>{journey.flags}</div>
          <div>{journey.uniqueDays}</div>
        </GridRow>
      ))}
    <GridRow noBackground>
      <div />
      <div />
      <div />
      <div />
      <SectionHeader>Totals</SectionHeader>
      <div>
        <strong>{patient.formsSent}</strong>
      </div>
      <div>
        <strong>{patient.formsCompleted}</strong>
      </div>
      <div>
        <strong>{patient.flags}</strong>
      </div>
      <div>
        <strong>{patient.uniqueDays}</strong>
      </div>
    </GridRow>
  </>
)

export default ({ doctor }) => (
  <>
    <Section header="Doctor" title={doctor.initials} />
    <Grid columns="1fr 1fr 1fr 4fr 1fr 1fr 1fr 1fr 1fr">
      <GridHeader>
        <SectionHeader>Patient Ref.</SectionHeader>
        <SectionHeader>Patient Initial</SectionHeader>
        <SectionHeader>T-Code</SectionHeader>
        <SectionHeader>Journey Name</SectionHeader>
        <SectionHeader>Start Date</SectionHeader>
        <SectionHeader>Forms Sent</SectionHeader>
        <SectionHeader>Forms Completed</SectionHeader>
        <SectionHeader>Alerts</SectionHeader>
        <SectionHeader>Unique Days</SectionHeader>
      </GridHeader>

      {doctor.patients
        .sort((a, b) => b.formsCompleted - a.formsCompleted)
        .map(patient => (
          <PatientTable patient={patient} />
        ))}
    </Grid>
    <Grid columns="9fr 2fr">
      <GridHeader border>
        <SectionHeader>Patient Count</SectionHeader>
        <SectionHeader>Completed Forms Total</SectionHeader>
      </GridHeader>
      <GridRow noBackground>
        <div>
          <strong>{doctor.patients.length}</strong>
        </div>
        <div>
          <strong>{doctor.formsCompleted}</strong>
        </div>
      </GridRow>
    </Grid>
  </>
)
